require('./components/preloader')
require('./components/header')
require('./components/faqDrop')
require('./components/product-specs')
require('./components/product-slider')
require('./components/product-tabs')
require('./components/video')
require('./components/form')
require('./components/contacts')
require('./components/scroll-to-section')
require('./components/contact-form')
